import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthStore } from "../+state/auth";

export const SecretariatOrMemberGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (
    (authStore.primaryOrganization()?.isSecretariat || authStore.primaryOrganization()?.isMember) &&
    authStore.isAdminRole()
  ) {
    return true;
  }

  router.navigate(["not-found"]);

  return false;
};
